module.exports = __webpack_public_path__ + "static/img/tab-my-none.4d7c810.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tab-my-none.png
// module id = 6vGl
// module chunks = 1